import { store } from '@/store/store.js';

export default (to, from, next) => {
  if (store.state.submission.reg) { // no data from api so forget it pal
    next();
  } else {
    next('/');
  }
};
